import { render, staticRenderFns } from "./HubTravels.vue?vue&type=template&id=153e04c6&"
import script from "./HubTravels.vue?vue&type=script&lang=js&"
export * from "./HubTravels.vue?vue&type=script&lang=js&"
import style0 from "./HubTravels.vue?vue&type=style&index=0&id=153e04c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports